// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vyhM","placeholdersHeader":"styles_placeholdersHeader__37Uts","editorStyle":"styles_editorStyle__3RSZh","placeholdersBox":"styles_placeholdersBox__20INK"};